module.exports = __webpack_public_path__ + "img/article-thumbnail.796ea638.jpg";